module.exports = __webpack_public_path__ + "static/media/odio-pay-logo-sky-blue.8983a026.svg";